module.exports = __webpack_public_path__ + "images/stickers/taco-trophy@2x.9143546ce5c8a3e43736.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-trophy@2x.png
// module id = HmYZ
// module chunks = 24